export default __webpack_public_path__ + "static/media/cesta.62f9f697.png";